import { motion } from "framer-motion";

const GOLD = "#C2A878";

export const MarquardtMask = ({ className = "", breathing = true }) => {
  const inner = (
    <svg
      viewBox="0 0 400 540"
      fill="none"
      style={{ width: "100%", height: "auto", filter: "drop-shadow(0 0 30px rgba(194,168,120,0.22))" }}
    >
      <motion.g
        stroke={GOLD}
        strokeWidth="0.75"
        strokeDasharray="3 5"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.45 }}
        transition={{ delay: 1.6, duration: 1 }}
      >
        <path d="M200 20 V510" />
        <path d="M105 60 H295" />
        <path d="M95 180 H305" />
        <path d="M115 330 H285" />
        <path d="M140 392 H260" />
        <path d="M168 478 H232" />
      </motion.g>

      <motion.path
        d="M200 25 L285 55 L312 160 L328 250 L285 375 L200 490 L115 375 L72 250 L88 160 L115 55 Z"
        stroke={GOLD}
        strokeWidth="1.4"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 2.2, ease: "easeInOut" }}
      />

      <motion.g
        stroke={GOLD}
        strokeWidth="1"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.9, duration: 1.2 }}
      >
        <path d="M200 60 L148 122 L120 185 M200 60 L252 122 L280 185" />
        <path d="M120 185 L165 172 L200 178 L235 172 L280 185" />
        <path d="M118 215 L141 200 L168 210 L164 229 L137 230 Z" />
        <path d="M282 215 L259 200 L232 210 L236 229 L263 230 Z" />
        <path d="M182 178 L196 302 M218 178 L204 302" />
        <path d="M170 332 L196 318 L204 318 L230 332" />
        <path d="M170 332 L184 346 L200 340 L216 346 L230 332" />
        <path d="M154 394 L200 384 L246 394 L200 416 Z" />
        <path d="M154 394 H246" />
        <path d="M88 250 L141 300 L122 372 M312 250 L259 300 L278 372" />
        <path d="M200 416 V452" />
        <path d="M122 372 L200 452 L278 372" />
      </motion.g>

      <motion.g
        fill={GOLD}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4, duration: 1 }}
      >
        <circle cx="143" cy="215" r="3.5" />
        <circle cx="257" cy="215" r="3.5" />
      </motion.g>
    </svg>
  );

  if (!breathing) return <div className={className} aria-hidden="true">{inner}</div>;

  return (
    <motion.div
      className={className}
      aria-hidden="true"
      animate={{ y: [0, -12, 0] }}
      transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
    >
      {inner}
    </motion.div>
  );
};
